import { Component, HostListener, Injectable } from '@angular/core'
import { SharedService } from '../../../@core/services/shared.service'
import { ActivatedRoute, Router } from '@angular/router'
import { NbDialogRef, NbDialogService, NbGlobalPhysicalPosition, NbMenuService, NbToastrService } from '@nebular/theme'
import { BasePageComponent } from '../../../@core/base-components/base-page.component'
import { UserService } from '../../../@core/services/user.service'
import { addDays, format, parseISO, subDays } from 'date-fns'
import { IWorkingDate, WorkingService } from '../../../@core/services/working.service'
import { SingleEmployeePickerComponent } from '../../../components/single-employee-picker/single-employee-picker.component'
import { EmployeeSortingComponent } from '../../../components/employee-sorting/employee-sorting.component'
import {
    ButtonType,
    FieldType,
    PvsFormDialogComponent,
    PvsFormResponse,
} from '../../../components/pvs-form-dialog/pvs-form-dialog.component'
import { Subscription } from 'rxjs'
import { TipDistributionComponent } from '../tip-distribution/tip-distribution.component'
import { RequestInformationComponent } from '../request-information/request-information.component'
import { SocketService } from '../../../@core/services/socket.service'
import { log } from 'util'
import { filter, map } from 'rxjs/operators'
@Component({
    selector: 'app-working-page',
    templateUrl: './working.component.html',
    styleUrls: ['./working.component.scss'],
})
@Injectable()
export class WorkingComponent extends BasePageComponent {
    pathParams = {}
    queryParams = {
        date: null,
    }
    pickerDate: Date
    dataSource: IWorkingDate
    summary = {
        turn: 0,
        amt: 0,
        cash: 0,
        cashPercent: 0,
        redeemAmt: 0,
    }
    menuEmployee = [{ title: 'Reorder employees' }, { title: 'Remove employee' }]
    workingDataChangedSub: Subscription
    customerCheckInSub: Subscription
    giftCardChangedSub: Subscription
    menuServiceSub: Subscription
    @HostListener('document:visibilitychange', ['$event'])
    visibilitychange() {
        // if (document.visibilityState === 'visible') {
        // refresh
        this.refreshData()
        // this.sharedService.showMessage('refresh')
        // }
    }
    constructor(
        public router: Router,
        public route: ActivatedRoute,
        public sharedService: SharedService,
        public userService: UserService,
        public workingService: WorkingService,
        private dialogService: NbDialogService,
        private socket: SocketService,
        private toastrService: NbToastrService,
        private nbMenuService: NbMenuService
    ) {
        super(router, route, sharedService, userService)
    }

    async onInit() {
        super.onInit()
        if (!this.queryParams.date) {
            this.queryParams.date = format(new Date(), 'yyyy-MM-dd')
            this.sharedService.setParamsToUrl(this.router, this.queryParams, this.pathParams)
        }
        this.getData(false)
        this.workingDataChangedSub = this.socket.on('working-data-changed').subscribe((data) => {
            console.log(`Socket IO: working-data-changed`, data)
            if (data?.salonId !== this.sharedService.currentSalon.id) {
                return
            }
            if (data?.workingDate !== this.queryParams.date) {
                return
            }
            this.refreshData()
        })
        this.customerCheckInSub = this.socket.on('customer-check-in').subscribe((data) => {
            console.log(`Socket IO: customer-check-in`, data)
            if (data?.salonId !== this.sharedService.currentSalon.id) {
                return
            }
            this.onSocketCustomerCheckIn(data)
        })
        this.giftCardChangedSub = this.socket.on('gift-card-changed').subscribe((data) => {
            console.log(`Socket IO: gift-card-changed`, data)
            if (data?.salonId !== this.sharedService.currentSalon.id) {
                return
            }
            if (data?.workingDate !== this.queryParams.date) {
                return
            }
            this.refreshData()
        })
        this.menuServiceSub = this.nbMenuService
            .onItemClick()
            .pipe(
                filter(({ tag }) => tag === 'menu-employees'),
                map(({ item: { title } }) => title)
            )
            .subscribe((title) => {
                console.log('onItemClick')
                switch (title) {
                    case 'Reorder employees': {
                        this.onReorderEmployee()
                        break
                    }
                    case 'Remove employee': {
                        this.onRemoveEmployee()
                        break
                    }
                }
            })
    }
    onDestroy() {
        super.onDestroy()
        this.workingDataChangedSub?.unsubscribe()
        this.customerCheckInSub?.unsubscribe()
        this.giftCardChangedSub?.unsubscribe()
        this.menuServiceSub?.unsubscribe()
    }
    onGoBackBrowserChanged() {
        super.onGoBackBrowserChanged()
        this.getData(false)
    }
    onSocketCustomerCheckIn(data) {
        if (!data?.hasAppointment && !data?.employee) {
            // walk-in customer & no request
            this.toastrService.control(
                `The walk-in customer (${data.firstName}) has just checked in.`,
                'New check-in (walk-in)',
                {
                    position: NbGlobalPhysicalPosition.BOTTOM_RIGHT,
                    duration: 10000,
                    icon: 'bell-outline',
                }
            )
            return
        }
        // has appointment or request specific employee
        let message
        if (data?.hasAppointment) {
            // has appointment
            if (!data?.employee) {
                message = `The customer (${data.firstName}) has an appointment with anyone.`
            } else {
                message = `The customer (${data.firstName}) has an appointment with ${data.employee.firstName}.`
            }
            this.toastrService.primary(message, 'New check-in (w/ appointment)', {
                position: NbGlobalPhysicalPosition.BOTTOM_RIGHT,
                duration: 120000,
                icon: 'bell-outline',
            })
        } else {
            // no appointment
            message = `The walk-in customer (${data.firstName}) has requested ${data.employee.firstName}. `
            this.toastrService.success(message, 'New check-in (walk-in)', {
                position: NbGlobalPhysicalPosition.BOTTOM_RIGHT,
                duration: 120000,
                icon: 'bell-outline',
            })
        }
    }
    getData(writeURLHistory: boolean = true) {
        // clear old data
        this.dataSource = {
            workingDate: '',
            employees: [],
            totalAmt: 0,
            totalAmtInCash: 0,
            totalTip: 0,
            actuallyCash: 0,
            actuallyCashHistories: [],
            note: null,
            noteHistories: [],
        }
        // clear summary
        this.calcSummary()
        // set picker
        this.pickerDate = parseISO(this.queryParams.date)
        // get new data
        this.workingService.getData(this.queryParams.date).subscribe((response: any) => {
            if (response?.data) {
                response.data.employees =
                    response.data.employees?.map((e) => {
                        return {
                            ...e,
                            turnCnt: this.workingService.calcTurnCnt(e.turns),
                        }
                    }) || []
                this.dataSource = response.data
                this.calcSummary()
            }
        })
        this.sharedService.setParamsToUrl(this.router, this.queryParams, this.pathParams, null, writeURLHistory)
    }
    refreshData() {
        this.workingService.getData(this.queryParams.date).subscribe((response: any) => {
            if (response?.data) {
                response.data.employees =
                    response.data.employees?.map((e) => {
                        return {
                            ...e,
                            turnCnt: this.workingService.calcTurnCnt(e.turns),
                        }
                    }) || []
                this.dataSource = response.data
                this.calcSummary()
            }
        })
    }
    changeDate(date) {
        const newDate = format(date, 'yyyy-MM-dd')
        if (this.queryParams.date !== newDate) {
            this.queryParams.date = newDate
            this.getData()
        }
    }
    prevDate() {
        this.queryParams.date = format(addDays(parseISO(this.queryParams.date), -1), 'yyyy-MM-dd')
        this.getData()
    }
    toDay() {
        this.queryParams.date = format(new Date(), 'yyyy-MM-dd')
        this.getData()
    }
    nextDate() {
        this.queryParams.date = format(addDays(parseISO(this.queryParams.date), 1), 'yyyy-MM-dd')
        this.getData()
    }
    addEmployee() {
        this.dialogService
            .open(SingleEmployeePickerComponent, {
                context: {
                    role: 'technician',
                    excluded: this.dataSource.employees.map((e) => e.employeeId),
                },
            })
            .onClose.subscribe((res) => {
                if (res) {
                    this.workingService.addNewEmployee(this.queryParams.date, res.id).subscribe((response) => {
                        this.dataSource.employees = this.dataSource.employees.concat([
                            {
                                workingDate: this.queryParams.date,
                                employeeId: res.id,
                                employee: res,
                                orderNo: this.dataSource.employees.length + 1,
                                turns: [],
                                totalAmt: 0,
                                totalAmtInCash: 0,
                                totalTip: 0,
                            },
                        ])
                    })
                }
            })
    }
    onEmployeeDataChange(employee) {
        // map to main data
        for (let e of this.dataSource.employees) {
            if (e.id === employee.id) {
                e = { ...employee }
                this.dataSource.employees = [...this.dataSource.employees]
                break
            }
        }
        this.calcSummary()
    }
    onReorderEmployee() {
        this.dialogService
            .open(EmployeeSortingComponent, {
                context: { employeeList: this.dataSource.employees.map((e) => e.employee) },
            })
            .onClose.subscribe((res) => {
                if (res) {
                    this.workingService
                        .reorderEmployees(
                            this.queryParams.date,
                            res.map((e) => e.id)
                        )
                        .subscribe((response) => {
                            this.refreshData()
                        })
                }
            })
    }
    onRemoveEmployee() {
        this.dialogService
            .open(SingleEmployeePickerComponent, {
                context: { employeeList: this.dataSource.employees.map((e) => e.employee) },
            })
            .onClose.subscribe((seRes) => {
                if (!seRes) {
                    return
                }
                this.dialogService
                    .open(PvsFormDialogComponent, {
                        context: {
                            settings: {
                                headerIcon: 'alert-triangle-outline',
                                title: 'Warning',
                                contentHtml: `
                            <p>You are trying to remove <strong>${seRes.firstName} ${seRes.lastName}</strong> from employee list.</p>
                            <p>All related data (turn amt, tip, redeem amt ...) cannot be restored after deletion.</p>
                            <p>Do you want to continue?</p>
                            `,
                                buttonType: ButtonType.YES_NO_10_SECONDS,
                            },
                        },
                    })
                    .onClose.subscribe((res: PvsFormResponse) => {
                        if (!res) {
                            return
                        }
                        this.workingService.removeEmployee(this.queryParams.date, seRes.id).subscribe((response) => {
                            // let i = this.dataSource.employees.findIndex((e) => e.employee.id === seRes.id)
                            // if (i >= 0) {
                            //     this.dataSource.employees.splice(i, 1)
                            //     this.calcSummary()
                            // }
                            this.refreshData()
                        })
                    })
            })
    }
    onTipSeparatorClick() {
        this.dialogService
            .open(TipDistributionComponent, {
                context: {
                    workingData: this.dataSource,
                },
            })
            .onClose.subscribe((res) => {
                if (res) {
                    // refresh
                    this.refreshData()
                }
            })
    }
    onRequestInformation() {
        this.dialogService.open(RequestInformationComponent, {}).onClose.subscribe((res) => {
            // if (res) {
            //     // refresh
            //     this.refreshData()
            // }
        })
    }
    calcSummary() {
        // clear
        this.summary.turn = 0
        this.summary.amt = 0
        this.summary.cash = 0
        this.summary.cashPercent = 0
        this.summary.redeemAmt = 0

        if (!this.dataSource?.employees?.length) {
            return
        }
        for (const e of this.dataSource.employees) {
            for (const t of e.turns) {
                if (t.amt > 0) {
                    this.summary.turn += 1
                }
                this.summary.amt += t.amt
                this.summary.cash += t.paidInCashAmt
                this.summary.redeemAmt += t.redeemAmt
            }
        }
        if (this.summary.amt > 0) {
            this.summary.cashPercent = Math.round((this.summary.cash / this.summary.amt) * 100)
        }
    }
    onActuallyCashUpdate() {
        this.dialogService
            .open(PvsFormDialogComponent, {
                context: {
                    settings: {
                        title: 'Actual cash',
                        fields: [
                            {
                                name: 'amt',
                                type: FieldType.NUMBER,
                                title: 'Cash amt',
                            },
                        ],
                        data: {
                            amt: this.dataSource.actuallyCash || null,
                        },
                        cssWidth: '400px',
                        okFunction: (data) => {
                            return this.workingService
                                .updateActuallyCash(this.queryParams.date, data.amt || 0)
                                .toPromise()
                        },
                    },
                },
            })
            .onClose.subscribe((res) => {
                if (!res) {
                    return
                }
                this.dataSource.actuallyCash = res.okFunctionResponse.data.actuallyCash
                this.dataSource.actuallyCashHistories = res.okFunctionResponse.data.actuallyCashHistories
            })
    }
    onNoteUpdate() {
        this.dialogService
            .open(PvsFormDialogComponent, {
                context: {
                    settings: {
                        title: 'Note',
                        fields: [
                            {
                                name: 'note',
                                type: FieldType.TEXT_AREA,
                                title: 'Content',
                                format: {
                                    textAreaRows: 10,
                                },
                            },
                            {
                                // prevent submit when enter new line
                                name: 'test',
                                disabled: true,
                            },
                        ],
                        data: {
                            note: this.dataSource.note,
                        },
                        okFunction: (data) => {
                            return this.workingService.updateNote(this.queryParams.date, data.note).toPromise()
                        },
                    },
                },
            })
            .onClose.subscribe((res) => {
                if (!res) {
                    return
                }
                this.dataSource.note = res.okFunctionResponse.data.note
                this.dataSource.noteHistories = res.okFunctionResponse.data.noteHistories
            })
    }
}
